import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const VoersDayCelebrationLawDepartment = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg31.jpg" },
  { img: "/assets/img/SOL/event/event1_mg32.jpg" }, 
  
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Voters Day Celebration At The Law Department" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>The Law Department of MVNU celebrated Voters Day with enthusiasm, aiming to promote voter awareness, civic responsibility, and the significance of democracy. The event witnessed active participation from faculty, students, and esteemed dignitaries, including the Honble Vice Chancellor (VC), Pro-Vice Chancellor (PVC), Registrar, and Chief Guest, Dr. Subhash Gupta.</p>

      
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default VoersDayCelebrationLawDepartment;
